import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const MenuIcon: FC<IconProps> = ({color = theme.palette.text.white, size}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 5.75C2 5.33579 2.34662 5 2.77419 5H17.2258C17.6534 5 18 5.33579 18 5.75C18 6.16421 17.6534 6.5 17.2258 6.5H2.77419C2.34662 6.5 2 6.16421 2 5.75Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 14.25C2 13.8358 2.34662 13.5 2.77419 13.5H17.2258C17.6534 13.5 18 13.8358 18 14.25C18 14.6642 17.6534 15 17.2258 15H2.77419C2.34662 15 2 14.6642 2 14.25Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 9.75C2 9.33579 2.34662 9 2.77419 9H17.2258C17.6534 9 18 9.33579 18 9.75C18 10.1642 17.6534 10.5 17.2258 10.5H2.77419C2.34662 10.5 2 10.1642 2 9.75Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
